import { PaginationPayload } from 'ra-core'
import { TicketAPISortPayload } from './ticket-api-get-list.params'

export const filterParamsComposer = (
  lambdaParameter: string,
  filterValues: any,
  filterMapper: (
    key: string,
  ) => (lambdaParameter: string, value: any, otherValues: any) => string,
): string => {
  const cleanedValues = Object.fromEntries(
    Object.entries(filterValues).filter(([, v]) => v != null),
  ) as Partial<typeof filterValues>

  if (Object.keys(cleanedValues).length === 0) {
    return 'true'
  }

  const filterParams = Object.entries(cleanedValues)
    .map(([key, value]) => {
      const mapper = filterMapper(key)
      return mapper(lambdaParameter, value, cleanedValues)
    })
    .filter(Boolean)

  return filterParams.length ? filterParams.join('&&') : 'true'
}

export const queryParamsComposer = (
  sort?: TicketAPISortPayload,
  pagination?: PaginationPayload | undefined,
  sortMapper?: (key: string) => string,
): string | null => {
  const queryParams: string[] = []
  if (sort && sortMapper && sortMapper(sort?.field)) {
    const { field, order } = sort
    queryParams.push(`sortBy=${sortMapper(field)}`)
    queryParams.push(`sortOrder=${order}`)
  }
  if (pagination) {
    const { page, perPage } = pagination
    queryParams.push(`rangeFrom=${page * perPage - perPage}`)
    queryParams.push(`rangeTo=${page * perPage - 1}`)
  }
  return queryParams.length > 0
    ? queryParams.reduce((p, c) => `${p}&${c}`)
    : null
}
